import type { RentalAgreementDto } from '../../services/api';
import { t } from '../../services/i18n';
import { PROPERTY_ICONS, escapeHtml, formatDate, isAgreementActive } from './property-shared';

function buildTenantDetailsUrl(agreement: RentalAgreementDto): string {
  const params = new URLSearchParams({
    tenant: agreement.tenantId,
    property: agreement.propertyId,
  });
  return `/tenants/?${params.toString()}`;
}

export class RcPropertyTenantsTab extends HTMLElement {
  agreements: RentalAgreementDto[] = [];

  render(): void {
    const toolbar = `
      <div class="tab-toolbar">
        <button class="btn btn-primary btn-sm" data-action="add-tenant">${PROPERTY_ICONS.plus} ${t('property.tenants.addButton')}</button>
        <button class="btn btn-outline btn-sm" data-action="link-tenant">${t('property.tenants.linkExistingButton')}</button>
      </div>
    `;

    this.innerHTML = this.agreements.length === 0
      ? `${toolbar}<div class="empty-state"><p>${t('property.tenants.empty')}</p></div>`
      : `${toolbar}
        <table>
          <thead><tr><th>${t('common.name')}</th><th>${t('common.rentAmount')}</th><th>${t('common.startDate')}</th><th>${t('common.endDate')}</th><th>${t('common.status')}</th><th></th></tr></thead>
          <tbody>
            ${this.agreements.map((agreement) => `
              <tr>
                <td>
                  <a class="tenant-name" href="${buildTenantDetailsUrl(agreement)}" style="color:inherit;font:inherit;text-decoration:underline;text-underline-offset:0.15em;">
                    ${escapeHtml(agreement.tenantName)}
                  </a>
                </td>
                <td>${agreement.rentAmount != null ? `&euro;${agreement.rentAmount.toFixed(2)}${t('property.perMonth')}` : '-'}</td>
                <td>${formatDate(agreement.startDate || '')}</td>
                <td>${agreement.endDate ? formatDate(agreement.endDate) : '-'}</td>
                <td><span class="badge ${isAgreementActive(agreement) ? 'badge-success' : 'badge-muted'}">${isAgreementActive(agreement) ? t('common.active') : t('common.ended')}</span></td>
                <td>
                  <div class="card-actions">
                    <button class="btn-icon" data-action="edit-agreement" data-id="${agreement.id}" title="${t('common.edit')}">${PROPERTY_ICONS.edit}</button>
                    ${isAgreementActive(agreement) ? `<button class="btn-icon btn-icon-primary" data-action="rent-change" data-id="${agreement.id}" title="${t('agreement.rentChange.title')}">${PROPERTY_ICONS.trend}</button>` : ''}
                  </div>
                </td>
              </tr>`).join('')}
          </tbody>
        </table>`;
  }
}

if (!customElements.get('rc-property-tenants-tab')) {
  customElements.define('rc-property-tenants-tab', RcPropertyTenantsTab);
}
